import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import InputAdornment from '@material-ui/core/InputAdornment';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import Search from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import moment from 'moment';

let counter = 0;

function getSorting(order, orderBy) {
 
  if (order === 'desc'){
    return (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
  }else{
    return (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1)
  }
  return 0
}

let count = 0

function getSorting(order, orderBy, thenBy) {

  if (order === 'desc'){
    return (a, b) => {
      count = count + 1

      if (b[orderBy] < a[orderBy] || b[thenBy] < a[thenBy]) return -1;
      if (b[orderBy] > a[orderBy] || b[thenBy] > a[thenBy]) return 1;
      return 0;
    }
  }else{
    return (a, b) => {
      if (b[orderBy] > a[orderBy] || b[thenBy] > a[thenBy]) return -1;
      if (b[orderBy] < a[orderBy] || b[thenBy] < a[thenBy]) return 1;
      return 0;
    }
  }
}

class SonicTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, columnData, checkbox } = this.props;

    return (
      <TableHead style={{textAlign: 'center'}} >
        <TableRow>
          
        {checkbox ?  
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell> : null }



          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
               // padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
                style={{textAlign: 'center'}} 
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                    style={{textAlign: 'center'}} 
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

SonicTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  columnData: PropTypes.array.isRequired
};

const toolbarStyles = theme => ({
  root: {
    flexGrow: 1,
   // paddingRight: theme.spacing.unit,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justify: 'flex-end',
    direction: 'row',
    margin: theme.spacing.unit * .5,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '0 0 auto',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  button: {
    margin: theme.spacing.unit * .5,
  },
  title: {

  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
});

let SonicTableToolbar = props => {
  const { numSelected, classes, title, search, checkbox, showDateSearch, toggleDateSearch, defaultDateRange, searchDateUpdated, searchDate } = props;


  const setPredefinedDate = (dateName) => {

    let endDate
    let startDate
    switch (dateName) {
      case 'today':
      endDate = moment()
      startDate = moment().startOf('day')
      break
      case 'yesterday':
      endDate = moment().add(-1, 'days')
      startDate = moment().add(-1, 'days').startOf('day')
      break
      case 'weekToDate':
      endDate = moment()
      startDate = moment().startOf('week').isoWeekday(1);
      break
      case 'monthToDate':
      endDate = moment()
      startDate = moment().startOf('month')
      break
      defualt:
      endDate = moment()
      startDate = moment().startOf('day')
    }

    searchDateUpdated('startDate', startDate)
    searchDateUpdated('endDate', endDate)
    searchDate()

  }

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0 && checkbox,
      })}
    >

    <div className={classes.root}>
    <Grid container alignItems={'center'}>
      

        <Grid item xs={6} className={classes.container}>
        <Button color="primary" className={classes.button} onClick={() => {setPredefinedDate('today')}}>Today</Button>
        <Button color="primary" className={classes.button} onClick={() => {setPredefinedDate('yesterday')}}>Yesterday</Button>
        <Button color="primary" className={classes.button} onClick={() => {setPredefinedDate('weekToDate')}}>Week</Button>
        <Button color="primary" className={classes.button} onClick={() => {setPredefinedDate('monthToDate')}}>Month</Button>
        <Button color={showDateSearch ? 'secondary' : 'primary'} className={classes.button} onClick={() => {toggleDateSearch()}}>{showDateSearch ? 'Close' : 'Custom'} </Button>
        {showDateSearch ? 
        <form className={classes.container} noValidate>
        <TextField
          id="datetime-local"
          label="Start"
          type="datetime-local"
          defaultValue={defaultDateRange.startDate.format('YYYY-MM-DDTHH:MM')}
          className={classes.textField}
          onChange={(event) => {searchDateUpdated('startDate', moment(event.target.value))}}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
        id="datetime-local"
        label="End"
        type="datetime-local"
        defaultValue={defaultDateRange.endDate.format('YYYY-MM-DDTHH:MM')}
        className={classes.textField}
        onChange={(event) => {searchDateUpdated('endDate', moment(event.target.value))}}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Button color="primary" className={classes.button} onClick={() => {searchDate()}}>Search</Button>
      </form> : null}
        </Grid>
        <Grid item xs={4}>
            <TextField
            fullWidth
            id="search"
            label="Search"
            type="search"
            onChange={search}
            className={classes.textField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            margin="normal"
          />
          </Grid>
      </Grid>
      </div>
    </Toolbar>
  );
};

SonicTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired
};

SonicTableToolbar = withStyles(toolbarStyles)(SonicTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
   // overflowX: 'auto !important',
  },
  table: {
    marginLeft: theme.spacing.unit * 3,
    overflowX: 'auto !important',
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'scroll !important',
  },
  row: {
    cursor: 'pointer',
    textAlign: 'center',
  }
});

class SonicTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: 'asc',
      orderBy: 'id',
      selected: [],
      page: 0,
      rowsPerPage: 100,
      showDateSearch: false
    };
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event, checked) => {
    const { rowData } = this.props
    if (checked) {
      this.setState({ selected: rowData.map(n => n.id) });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {

    console.log(event)
    console.log(event.target)

    const { selected } = this.state;
    const { checkbox, rowsSelected } = this.props
    const selectedIndex = selected.indexOf(id);

    let newSelected = [];

    if (checkbox){

        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1),
          );
        }
    }else{
      newSelected.push(id)
      rowsSelected([id])
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };
  searchStringChanged = (event) => {
    //need to add partial match with option on toolbar
    //need to add check to see if new query is needed and to push back to parent and skip internal filter. Let get set via a prop
    const value = event.target.value
    let isFiltering = true
   // clearTimeout(saveTimeout);
    if (value === '' || value === undefined || value === null){
      isFiltering = false
    }
    this.setState({isFiltering, filterString: value})
    /*saveTimeout = setTimeout(() => {
      this.setState({isFiltering, event})
    }, 1000);*/
  }
  
  makeRows = () => {

    const { classes, rowData, checkbox } = this.props;
    const { order, orderBy, selected, rowsPerPage, page, isFiltering, filterString } = this.state;

    let data = rowData.slice(0)
    console.log(isFiltering)
    if (isFiltering){
        data = data.filter(item => {
            const rawString = JSON.stringify(item)
            return rawString.includes(filterString)
          })

          console.log(data)
    }

    console.log(data)


    const rows = data
      .sort(getSorting(order, orderBy, 'soldEpoch'))
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map(n => {
        const isSelected = this.isSelected(n.id);
        if (checkbox){
            return (
                  <TableRow
                    hover
                    className={classes.row}
                    onClick={event => this.handleClick(event, n.id)}
                    role="checkbox"
                    aria-checked={isSelected}
                    tabIndex={-1}
                    key={n.id}
                    selected={isSelected}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox checked={isSelected} />
                    </TableCell>
                    {this.makeTableCells(n)}
                  </TableRow>
                );
          }else{
            return (
              <TableRow
                hover
                onClick={event => this.handleClick(event, n.id)}
                tabIndex={-1}
                key={n.id}
                selected={isSelected}
              >
                {this.makeTableCells(n)}
              </TableRow>
            );
          }
      })

      console.log(rows)
      //need to account for empty array and let user choose as prop
     /* if (rows.length < rowsPerPage){
        for (let rowCount = rows.length; rowCount < rowsPerPage; rowCount++) {
            rows.push(<TableRow style={{ height: 49}}>
            <TableCell colSpan={6} />
          </TableRow>)
        }
      }*/


      return rows
  }
  makeTableCells = (item) => {
    let itemCount = 0;
    const tableCells = Object.keys(item).map(key => {
        itemCount =  itemCount + 1
        return <TableCell  style={{textAlign: 'center'}}  key={itemCount} component="th" scope="row" padding="none">{item[key]}</TableCell>
      })
    return tableCells
  };
  toggleDateSearch = () => {
    this.setState({showDateSearch: !this.state.showDateSearch})
  };
  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, rowData, columnData, title, checkbox, defaultDateRange, searchDateUpdated, searchDate } = this.props;
    const { order, orderBy, selected, rowsPerPage, page, showDateSearch } = this.state;


    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rowData.length - page * rowsPerPage);

    return (
      <Paper className={classes.root}>
       {/*   <SonicTableToolbar 
        numSelected={selected.length} 
        title={title} 
        search={this.searchStringChanged} 
        checkbox={checkbox} 
        showDateSearch={showDateSearch} 
        toggleDateSearch={this.toggleDateSearch} 
        defaultDateRange={defaultDateRange}
        searchDateUpdated={searchDateUpdated}
        searchDate={searchDate}
        />*/}
      {/*  <div className={classes.tableWrapper}>*/}
      <Grid item xs={12}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <SonicTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={rowData.length}
              columnData={columnData}
            />
            <TableBody>
              {this.makeRows()}
            </TableBody>
          </Table>
          </Grid>
      {/*  </div> */}
        <TablePagination
          component="div"
          count={rowData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

SonicTable.propTypes = {
  classes: PropTypes.object.isRequired,
  rowData: PropTypes.array.isRequired
};

export default withStyles(styles)(SonicTable);


// WEBPACK FOOTER //
// ./src/components/lib/SonicTable.js